export default __webpack_public_path__ + "static/media/Aloe-Vera-Hyaluronic-Ac.5308ea2a.png";